export default {
  data () {
    return {}
  },
  methods: {
    errorStatusAvaible (error) {
      return error.response ? error.response.status : error.response
    }
  }
}
